module.exports = __webpack_public_path__ + "img/mobile-screen_sp.6845e66b.png";